/* 不要修改任何代码！不要修改任何代码！不要修改任何代码！！！！ */
/* 通用处理 跳转不同新建or修改 or详情页面的判断 */
/* 这是一个单纯处理跳转路径的js 不推荐引入业务需求和代码 */
/* 不要修改任何代码！不要修改任何代码！不要修改任何代码！！！！ */
// import { MediaCloudGateway } from 'common-mediax/src/apis'
import * as apis from '../apis/index'
import { serviceLocation as service } from './index'
import Whitelist from './whitelist'
import SM4 from './sm4'

/* moduleId对照数据 */
/* 不要修改！！！ */
const serviceId = {
  6: 'origin',
  240: 'dep',
  260: 'audit',
  2: 'app',
  1: 'web',
  60: 'wx',
  63: 'weibo', //新增一个微博的
  222: 'paper',
  264: 'journal', // 期刊
  89: 'videos',
  133: 'planning',
  100000: 'planning',
  86: 'tv',
  87: 'tvGroup',
  270: 'my',
  301: 'proSource',
  302: 'proSource',
  303: 'proSource',
  304: 'assetArticle',
  258: 'themeLinkage'
}

/* 通常情况下的稿件类型和对应a_type */
/* 不要修改！！！ */
const articleTypeCode = {
  16: '', //核校稿。。。
  0: '', //文章一般无
  1: 'Photos', //组图
  2: 'Video', //视频
  3: 'Special', //专题
  4: 'Link', //链接
  6: 'Live', //直播
  7: 'Activity', //活动
  9: 'Compilation', //合辑
  10: 'Subject', // 专题
  14: 'Vote', // 投票
  15: 'Audio', //音频
  28: 'TV' // 电视（2025年5月21日添加 目前只有稿源库和个人稿库拥有电视类型稿件
}

/* channel对照数据 */
/* 不要修改！！！ */
const channelMap = {
  origin: 0,
  app: 2,
  web: 1,
  wx: 4,
  weibo: 8,
  tv: 32,
  douyin: 64,
  paper: 128,
  journal: 16391, //期刊
  planning: 133
}

function getArticleTypeCode(type) {
  // 如果有特殊情况 可以在这里加逻辑判断
  return articleTypeCode[type]
}

function getDetailUrl(code) {
  // 如果有特殊情况 可以在这里加逻辑判断
  return service.getDetailKeyWordByCode(code)
}

/**
 * 路由信息格式处理
 * @param route
 */
export async function routerFormat(route) {
  // 参数key集合
  let queryKeys = Object.keys(route.query)
  if (route.path === '/login') {
    // 登录页面无用户信息，不存在加密，不进行校验
    return true
  }
  // 标识是否含有白名单参数
  let isWhite = false
  queryKeys.forEach((item) => {
    if (Whitelist.routeWhiteLimit.includes(item)) {
      isWhite = true
    }
  })
  if (isWhite && !route.query.akt) {
    // 还有白名单参数，不能有akt参数，重新进行加密
    window.location.href = getOpenUrl({
      url: route.path,
      params: route.query
    })

    return true
  }
  if (
    route.query &&
    queryKeys.length > 0 &&
    (!route.query.akt || queryKeys.length > 1)
  ) {
    // 存在路由参数，但是不存在akt参数或者存在除akt外其他参数，表示含有非法参数
    window.sessionStorage.setItem(
      'errorMsg',
      '系统检测到URL含有非法参数\n为了您的数据安全，建议关闭当前页面。'
    )
    window.location.href = '/error'
  } else if (route.query && route.query.akt) {
    try {
      const sm4 = new SM4()
      // 检测是否存在akt参数，存在即表示参数经过了加密，需要解密
      let paramsStr = sm4.decrypt(route.query.akt)
      let paramsObj = {}
      // 解密后的参数字符串转换成对象
      paramsStr.split('&').forEach((item) => {
        let [key, value] = item.split('=')
        paramsObj[key] = decodeURIComponent(value)
      })
      // 将解密后的参数对象赋给route.query
      Object.assign(route.query, paramsObj)
    } catch (e) {
      window.sessionStorage.setItem(
        'errorMsg',
        '系统检测到您已重新登录\n为了您的数据安全，建议关闭当前页面。'
      )
      window.location.href = '/error'
    }
  }
}
/**
 * 新开页面url参数构建方法
 * @param url
 * @param params
 * @returns {string}
 */
export function getOpenUrl({ url, params }) {
  let arr = []
  let prefix = url.startsWith('http') ? '' : '/'
  if (url.startsWith('/')) {
    // 如果url以/开头，为保证返回格式统一，需要将其移除，返回时自动添加/
    url = url.slice(1)
  }
  for (let key in params) {
    if (typeof params[key] === 'object') {
      params[key] = JSON.stringify(params[key])
    }
    arr.push(key + '=' + encodeURIComponent(params[key]))
  }
  // 构建sm4加密实例
  const sm4 = new SM4()
  // 存在参数，且是以open开头，则进行加密
  if (arr.length > 0 && prefix) {
    let encryptStr = sm4.encrypt(arr.join('&'))
    return prefix + url + '?akt=' + encryptStr
  } else {
    return prefix + url + '?' + arr.join('&')
  }
}

// 详情页、及其他操作
/* 不要修改！！！ */
export function modulesOpenWindow(url, params) {
  let base, code
  if (!params.docLib && !params.code) {
    code = service.getService()
  } else if (params.code) {
    code = params.code
  } else if (params.docLib) {
    code = serviceId[params.docLib]
  }
  let modulesUrl = url
  if (url === 'detail') {
    // 获取不同稿库详情页路由的最后一部分字符串
    modulesUrl = getDetailUrl(code)
    if (code === 'app' || code === 'web') {
      params.ids = params.id
      params.columnName = params.column
      params.column = params.columnId

      base = { base: params }
    } else if (code === 'planning') {
      let metadata = JSON.parse(params.metadata)
      metadata.ids = params.id
      metadata.typeStr = params.a_typeName
      metadata.folderType = params?.folderType || 0 // 0:选题策划，1:策划会
      base = { base: metadata }
    } else if (code === 'paper') {
      base = {
        id: params.id,
        columnId: params.columnId,
        column: params.column,
        type: params.type,
        status: params.status
      }
      // modulesUrl += `?id=${params.id}&columnId=${params.columnId}&column=${params.column}&type=${params.type}&status=${params.status}`
    } else if (code === 'proSource') {
      params.ids = [params.id]
      params.columnName = params.column
      params.column = params.columnId
      if (params.type === 1) {
        // 视频详情
        modulesUrl += 'ProductionSource-VideoDetail'
      } else if (params.type === 2) {
        // 音频详情
        modulesUrl += 'ProductionSource-AudioDetail'
      } else if ([3, 4].includes(params.type)) {
        // 图片详情
        modulesUrl += 'ProductionSource-PhotoDetail'
      } else if (params.type === 6) {
        // 文章详情
        modulesUrl += 'ProductionSource-DocDetail'
      }
      base = { base: params, ids: params.ids }
    } else {
      base = params
    }


    if(params.stauts) {
      base.status = params.status
    }
  } else if (url.indexOf('traces') > 0 || url.indexOf('Traces') > 0) {
    if (code === 'web') {
      base = {
        base: {
          id: params.id,
          ids: [params.id],
          column: params.columnId || params.column
        }
      }
    } else {
      base = { base: { id: params.id, ids: [params.id] } }
    }
    if (params.mod) {
      base.base.mod = params.mod
    }
  } else if (url === 'print') {
    modulesUrl = code != 'tv' ? 'ArticlePrint' : 'article-tv-articlePrint'
    base = { ids: params.ids }
    if (params.picAttIds) {
      // 纸媒精选需要记录图片的picAttIds
      base.picAttIds = params.picAttIds
    }
  } else {
    base = params
  }
  window.open(
    getOpenUrl({
      url: `open/${service.getOpenCommonPath(code)}${modulesUrl}`,
      params: base
    })
  )
}

// 新增、编辑稿件执行新开窗口
/* 不要修改！！！ */
export function modulesOpenEditArticleWindow(params, action) {

  let code
  if (!params.docLib && !params.code) {
    code = service.getService()
  } else if (params.code) {
    code = params.code
  } else if (params.docLib) {
    code = serviceId[params.docLib]
  }
  // 忘记是为了兼容谁了
  code = code === 'root' ? 'origin' : code
  let typeCode = ''
  if (code !== 'planning' && code.indexOf('tv') === -1) {
    typeCode = getArticleTypeCode(params.type)
  }
  // 拼接最终跳转的页面地址
  // 基本逻辑：不同微服务的新建前缀 + 新建稿件类型code
  let url
  if (code.indexOf('tv') === -1) {
    url = service.getAddKeyWordByCode(code) + typeCode
  } else if (code === 'tv') {
    url = 'mediacloud-article-wx/article-tv-ArticleAdd'
  } else if (code === 'tvGroup') {
    url = 'mediacloud-article-wx/article-tv-SingleAdd'
  }
  if (code === 'weibo') {
    url = 'mediacloud-article-wx/article-wb-create' //微博头条文章
  }
  if(code === 'themeLinkage'){
    url = 'ThemeLinkageAdd'
  }
  // 通用得base参数
  let base = {
    columnId: params.columnId,
    column: params.column,
    type: params.type
    // status: params.status
  }

  // 修改页面需要的id参数
  if (params.id) {
    base.id = params.id
    base.ids = [params.id]
  }
  // channel参数
  // 是新建修改接口的必传参数 后端对应的参数值见 channelMap 定义值 这里做写死处理
  if (params.channel || params.channel === 0) {
    //等于 0 是稿源库的
    base.channel = params.channel
  } else if (code in channelMap) {
    base.channel = channelMap[code]
  }
  if (params.isTranslation) {
    base.isTranslation = params.isTranslation
  }
  // 理论上必传的status参数
  if (params.a_status || params.status) {
    base.status = params.a_status || params.status
  }

  // 从远端稿库选用时进入编辑页,判断是否是云端稿库进入的编辑页
  if (params.from === '201' || params.from === '205') {
    base.casName = params.casName
    // base.targetLib = params.targetLib
    // base.folder = params.folder
    // base.module = params.module
  }

  // opener 判断是否是详情页或者非列表位置打开得编辑页
  // 用于对父页面或者列表页面的更新逻辑判断
  if (params.opener) {
    base.opener = params.opener
  }

  // 一般是列表页的搜索关键字带入详情页才会有这个参数 这里忘记为什么传了
  if (params.searchKeys) {
    base.searchKeys = params.searchKeys
  }

  // 现在抖音 bilibili 快手 统一都叫视频号 同理 媒体号也是
  // 需要用 platformCode 参数做类型区别以满足后端需要的不同入参结构
  if (params.platformCode) {
    base.platformCode = params.platformCode
  }
  // 指挥策划写稿关联用id
  if (params.planTopicId) {
    base.planTopicId = params.planTopicId
  }
  if (params.planID) {
    base.planID = params.planID
  }
  if(params.themeId){
    // 主题联动
    base.themeId = params.themeId
  }
  // forward或from参数：
  // 见报成品选用 或数字报选用 或报料转稿件时使用 或高级检索跳转需要
  // 后续追加的选用方法 一律复用forward和from
  if (params.forward || params.from) {
    // 通用的无业务forward 可传 -1
    if (params.forward) {
      base.forward = params.forward
    }
    // from 可传 -1
    if (params.from) {
      base.from = params.from
    }
    // 报料转稿件用的
    if (params.tipOffID) {
      base.tipOffID = params.tipOffID
    }
    // 好像是见报成品在用
    if (params.otherId) {
      base.otherId = params.otherId
    }
    // 数字报在用
    if (params.fromId) {
      base.fromId = params.fromId
    }
    // 数字报选用编辑
    if (params.isSelect4Edit) {
      base.isSelect4Edit = params.isSelect4Edit
    }
  }
  // 选题策划特有的状态中文参数（你说后端得多懒把
  if (params.a_typeName || params.typeStr) {
    base.typeStr = params.a_typeName || params.typeStr
  }
  // 社圈转稿件使用postID 传递互动运营id
  if (params.postID) {
    base.postID = params.postID
  }
  // 小记者投稿稿件使用reporterSubmissionID
  if (params.reporterSubmissionID) {
    base.reporterSubmissionID = params.reporterSubmissionID
    if (params.from) {
      base.from = params.from
    }
    if (params.fromId) {
      base.fromId = params.fromId
    }
  }
  // 理论上不应该存在 但必须兼容旧有的预览功能
  // 等待淦掉
  if (params.metadata) {
    base.metadata = params.metadata
  }

  if (code === 'app' || code === 'web') {
    // app和web发布库特有的站点参数
    base.siteID = params.site || params.siteID
    if (base.id) {
      base.ids = base.id
    }
    if (params.siteName) {
      base.siteName = params.siteName
    }
  }

  if (action && action.actionToken) {
    base.action = action.id
    base.actionToken = action.actionToken
  }

  // 获取编辑页面样式（稿签在左或者在右）的接口
  // 永远不能放到编辑页面调用 会导致编辑器加载不出来白屏的情况
  apis.MediaCloudGateway.getMainUserPreference({}).then((preference) => {
    if (preference.data.status === 0) {
      let preferenceConfig = preference.data.data
      if (preferenceConfig.uiinterfaceStyle) {
        base.layoutDirection =
          preferenceConfig.uiinterfaceStyle === '样式二' ? 1 : 0
      } else {
        base.layoutDirection = 0
      }

      let theEditWindow
      if (code === 'paper') {
        let paperParams = {
          id: params.id,
          layoutDirection: base.layoutDirection,
          columnId: params.columnId,
          column: params.column,
          type: params.type
        }
        if (base.actionToken) {
          paperParams.actionToken = base.actionToken
        }
        // 报纸的陈年路由 等一个重做
        theEditWindow = window.open(
          getOpenUrl({
            // 微服务路由的前缀 + url
            url: `open/${service.getOpenPath(code)}${url}`,
            params: paperParams
          }),
          '_blank'
        )
      } else if (code === 'tv' || code === 'tvGroup' || code === 'weibo') {
        // 电视文稿和串联单特殊 因为他俩是同一个路由没法用通用得页面路由区分,微博共用这套逻辑
        theEditWindow = window.open(
          getOpenUrl({
            // 微服务路由的前缀 + 拼接好的url
            url: `open/${url}`,
            params: base
          }),
          '_blank'
        )
      } else {
        let windowName = ''
        if (params && params.id) {
          windowName = 'edit_article_' + params.id
        } else {
          // 从URL中提取路径部分作为窗口名
          const match = url.match(/article-[^\/-]+-[^\/-]+/)
          windowName = match ? match[0] : url
        }
        // 非报纸编辑页面跳转
        theEditWindow = window.open(
          getOpenUrl({
            // 微服务路由的前缀 + 拼接好的url
            url: `open/${service.getOpenPath(code)}${url}`,
            params: base
          }),
          windowName,
        )
      }
      if (action && action.actionToken && base.id) {
        window.setUnlockLoop = true
        if (!window.setUnlockLoop || !window.setUnlockLoop.length) {
          window.setUnlockLoop = [action.actionToken]
        } else {
          window.setUnlockLoop.push(action.actionToken)
        }

        let loop = setInterval(function () {
          let baseParam = {
            action: action.id,
            actionToken: action.actionToken,
            ids: [base.id]
          }

          let opener = base.opener || ''
          let microServicePrefix = service.getApiUrlByCode('Edit', code)
          if (theEditWindow.closed) {
            clearInterval(loop)

            apis[microServicePrefix]
              .postAction({
                headers: {
                  'base-param': JSON.stringify(baseParam)
                }
              })
              .then((resp) => {
                if (resp.data.status === 0) {
                  if (
                    opener !== 'dialogEdit' &&
                    action.actionSuccessCustomFunc
                  ) {
                    // 自定义的刷新一次列表回调 主要是选题策划在使用
                    action.actionSuccessCustomFunc()
                  } else if (
                    opener !== 'dialogEdit' &&
                    action.actionSuccessCb
                  ) {
                    // 刷新一次列表
                    // action.actionSuccessCb()
                    window.postMessage(
                      {
                        type: 'e5RefreshTable',
                        e5MainName: service.getE5MainName() // e5Main的名字
                      },
                      location.origin
                    )
                  } else if (opener === 'dialogEdit' && window.opener) {
                    // 详情页手动刷新列表并手动刷新页面
                    window.opener.postMessage(
                      {
                        type: 'e5RefreshTable',
                        e5MainName: service.getE5MainName() // e5Main的名字
                      },
                      location.origin
                    )
                    window.location.reload()
                  }
                  if (window.setUnlockLoop && window.setUnlockLoop.length) {
                    window.setUnlockLoop = window.setUnlockLoop.filter(
                      (item) => item !== baseParam.actionToken
                    )
                  }
                }
              })
          }
        }, 1000)

        // theEditWindow.focus()
      }
    }
  })
}
